<template>
<section class="org-wrapper">
  <section class="org-list-wrapper">
    <org-list-edit />
  </section>
  <section class="user-list-wrapper">
    <user-list-editor :org-site-devices="orgSiteDevices" style="padding-top:2em;" />
  </section>
</section>
</template>

<script>
import OrgListEdit from './OrgListEdit'
import UserListEditor from './UserListEditor'
import BaseStore from '../../../components/BaseStore'

export default {
  name: 'SystemSettingsOrgUser',
  routeInfo: {
    label: '组织管理',
    icon: 'fa fa-users',
    curdInfo: {
      api: 'Org',
      id: 'id',
      name: 'name',
      editName: '组织'
    }
  },
  extends: BaseStore,
  components: {UserListEditor, OrgListEdit},
  data: () => ({
    orgSiteDevices: Object.freeze([])
  }),
  created () {
    this.changeLoadStatus(true)
    this.$api.Profile.getOrgSiteDevices().then(orgSiteDevices => {
      this.orgSiteDevices = Object.freeze(orgSiteDevices)
    }).catch(console.error).finally(() => {
      this.changeLoadStatus(false)
    })
  }
}
</script>

<style lang="scss" scoped>
.org-wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .layout-content-wrapper {
    /deep/ {
      .layout-content-body-inner {
        padding: {
          right: 12px;
          bottom: 12px;
          left: 12px;
        }
      }
    }
  }

  > {
    .org-list-wrapper,
    .user-list-wrapper {
      width: 100%;
      height: 50%;
    }

    .user-list-wrapper {
      > .layout-content-wrapper {
        /deep/ {
          .layout-content-header {
            top: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/02Org/index.vue